import * as React from 'react'

import { CalendarIcon } from '@radix-ui/react-icons'
import { format } from 'date-fns'
import { DateRange } from 'react-day-picker'

import { cx } from '@/lib/cva-config'
import { Button } from './button'
import { Calendar } from './calendar-v2'
import { Popover, PopoverContent, PopoverTrigger } from './popover'

interface DatePickerWithRangeProps {
  value?: DateRange | undefined
  onChange?: (value: DateRange | undefined) => void
  placeholder?: string
  numberOfMonths?: number
  className?: string
  buttonClassName?: string
}

export function DatePickerRange({
  value,
  onChange,
  placeholder = 'Pick a date',
  numberOfMonths = 2,
  className,
  buttonClassName,
  ...rest
}: DatePickerWithRangeProps) {
  const [date, setDate] = React.useState<DateRange | undefined>(value)
  const handleDateChange = React.useCallback(
    (selectedDate: DateRange | undefined) => {
      setDate(selectedDate)
      if (onChange) {
        onChange(selectedDate)
      }
    },
    [onChange, setDate]
  )

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant={'outline'}
          className={cx(
            'w-[240px] justify-start text-left font-normal',
            !date && 'text-gray-300',
            buttonClassName
          )}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {date?.from ? (
            date.to ? (
              <>
                {format(date.from, 'LLL dd, y')} -{' '}
                {format(date.to, 'LLL dd, y')}
              </>
            ) : (
              format(date.from, 'LLL dd, y')
            )
          ) : (
            <span>Pick a date</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="range"
          defaultMonth={date?.from}
          selected={date}
          onSelect={handleDateChange}
          // numberOfMonths={numberOfMonths}
          autoFocus
        />
      </PopoverContent>
    </Popover>
  )
}
